export const ErrorMessage = ({ error }) => (<p className="font-medium text-xs text-red-600 mt-1">{error}</p>);
